import { Label as LabelPrimitive } from "radix-ui";
import type * as React from "react";
import { cn } from "@/lib/utils";

/** KORI `.label`. */
function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn("inline-flex items-center gap-2 font-sans text-sm font-semibold leading-snug text-ink", className)}
      {...props}
    />
  );
}

export { Label };
